import {
  Caption,
  H3Heavy,
  MediaQuery,
  TextSkeleton,
} from '@pelando/components';
import styled from 'styled-components';

export const StoreExpiredCouponContainer = styled.div`
  grid-area: expireds;
  margin: 32px 0;
  padding: 0 12px;

  @media ${MediaQuery.SCREEN_MD_UP} {
    margin-top: 48px;
    margin-bottom: 0;
    padding: 0;
  }
`;

export const StoreExpiredCouponTitle = styled.h3`
  display: none;

  @media ${MediaQuery.SCREEN_MD_UP} {
    ${H3Heavy};
    display: block;
  }
`;

export const StoreExpiredCouponSkeletonTitle = styled(TextSkeleton)`
  display: none;

  @media ${MediaQuery.SCREEN_MD_UP} {
    display: block;
    height: 24px;
    width: 96px;
    border-radius: 30px;
  }
`;

export const StoreExpiredCouponSubTitle = styled.p`
  display: none;

  @media ${MediaQuery.SCREEN_MD_UP} {
    ${Caption};
    margin-top: 4px;
    display: block;
  }
`;

export const StoreExpiredCouponSkeletonSubtitle = styled(TextSkeleton)`
  display: none;

  @media ${MediaQuery.SCREEN_MD_UP} {
    margin-top: 4px;
    display: block;
    height: 18px;
    max-width: 243px;
    border-radius: 30px;
  }
`;

export const StoreExpiredCouponsList = styled.div`
  display: grid;
  grid-auto-rows: 1fr;
  grid-gap: 8px;
  @media ${MediaQuery.SCREEN_MD_UP} {
    margin-top: 16px;
  }
`;
